<template>
  <div>
    <!-- بلوک اطلاعات کاربر و لاین -->
    <CRow v-if="line_info.title!=null" class="mb-3">
      <CCol col="12">
        <CCard>
          <CCardBody>
            <div class="d-flex align-items-center justify-content-between user-line-info">
              <img :src="admin_info.image" class="rounded-circle user-avatar" width="70px" height="70px"/>

              <div class="user-line-details mr-4">
                <h5 class="mb-1">
                  <strong>{{$t('line')}} {{ line_info.title }}</strong>
                </h5>
                <p class="mb-0 text-muted">
                  {{ admin_info.name }}
                </p>

              </div>
              <button class="btn-primary" @click="openScheduleModal">
                📅 تنظیمات زمان‌بندی
              </button>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <!-- سکشن تقویم جدید در ابتدای صفحه -->
    <CRow v-if="line_info.title!=null" class="mb-3">
      <CCol col="12">
        <CCard>
          <CCardHeader>
          </CCardHeader>
          <CCardBody>
            <div class="calendar-section">
              <date-picker
                  v-model="selected_date"
                  inline
              />
            </div>
            
            <!-- راهنمای استفاده -->
            <div class="calendar-guide mt-2 mb-2">
              <small class="text-muted">
                <i class="fa fa-info-circle mr-1"></i>{{ $t('by_click_in_hours_is_disable') }}</small>
            </div>
            
            <!-- نمایش ساعات رزرو زیر تقویم -->
            <div class="reserve-times-section mt-3 mb-3">
              <div v-if="line_reserves.length>0">
                <CButton
                    size="sm"
                    color="danger"
                    @click="delete_item_dialog(line_info)"
                    class="mb-2 w-100"
                    style="padding: 0.5rem 0.9rem !important;"
                >{{ $t('delete_all_hours_in_day') }}
                  {{get_date(selected_date)}}</CButton>
                <div :class="`reserve_time_list`">
                  <div :key="'time'+reserve.id" v-for="reserve in line_reserves" class="reserve_time_parent">

                    <div  @click="change_time_status(reserve)"
                           :class="`reserve_time_item ${reserve.orders_count>0? 'reserved':'' } ${reserve.status==0? 'disabled':'' }`"
                    >
                      {{get_time(reserve.date)}}
                    </div>
                    <CButton size="sm" color="danger" @click="delete_item_dialog_one(reserve)"><CIcon name="cil-trash" color="white" /></CButton>
                  </div>
                </div>
              </div>

              <div v-else class="text-center text-muted py-3">{{ $t('day_has_not_reservation_hours') }}</div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <!-- بلوک ثبت ساعات رزرو -->
    <CRow v-if="line_info.title!=null" class="reserve-form-section">
      <CCol col="12">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('add_reservation_hours') }}</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="6 col-md-6">
                <date-picker
                    v-model="start_time"
                    :label="$t('from')"
                    display-format="HH:mm"
                    input-format="HH:mm"
                    format="HH:mm"
                    type="time"
                />
              </CCol>

              <CCol col="6 col-md-6">
                <date-picker
                    v-model="end_time"
                    :label="$t('to_hours')"
                    display-format="HH:mm"
                    input-format="HH:mm"
                    format="HH:mm"
                    type="time"
                />
              </CCol>

              <CCol col="12 col-md-6">
                <CInput
                    v-model="every_minute"
                    :label="$t('per_minutes')"
                    v-on:keypress="isNumber($event)"
                />
              </CCol>
            </CRow>

          </CCardBody>
          <CCardFooter>
            <CButton v-if="status_form==0"
                     @click="login()"
                     type="submit" ref="submit_form" size="sm" color="primary" style="padding: 0.5rem 0.9rem !important;">{{ $t('add_reservation_list_hours') }}</CButton>

            <CButton v-if="status_form!=0"
                     @click="cancel_form()"
                     class="mr-1"
                     size="sm" color="danger">
              {{ $t('cancel') }}
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <work-schedule-modal
        v-if="showScheduleModal"
        :show="showScheduleModal"
        :admin-id="admin_info.id"
        :line-id="line_info.id"
        :admin-name="admin_info.name"
        :line-name="line_info.title"
        @close="closeScheduleModal"
    />
  </div>

</template>

<script>
import axios from "axios";
import WorkScheduleModal from './WorkScheduleModal.vue';

import {bus} from '../../main';


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: new Date().getTime() + "_" + this.$vnode.tag,
      confirm_delete_name_one: new Date().getTime() + "_one_" + this.$vnode.tag,
      selected_date: '',
      selected_time: 0,
      name: '',
      code: '',
      file: [],
      line_info: {},
      admin_info: {},
      color: '',
      previewImage: null,
      description: '',
      start_time: '09:00',
      end_time: '20:00',
      every_minute: 60,
      line_reserves: [],

      status_form: 0,
      showScheduleModal: false,

    }
  },
  components:{
    WorkScheduleModal
  },
  mounted() {
    this.selected_date = this.get_today()
    this.get_categories();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    bus.$on(this.confirm_delete_name_one, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item_one();
      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'selected_date':function (){
      this.get_line_reserve_times()
    }
  },
  methods: {
    openScheduleModal() {


      if (!this.admin_info.id || !this.line_info.id) {
        this.showError('لطفاً ادمین و لاین را انتخاب کنید.');
        return;
      }
      this.showScheduleModal = true;
    },

    closeScheduleModal() {
      this.showScheduleModal = false;
    },

    showError(msg) {
      if (this.$toast) this.$toast.error(msg);
      else alert(msg);
    },
    cancel_form() {
      this.name = '';
      this.description = '';
      this.previewImage = null;
      this.file = [];

      this.status_form = 0;

    },
    editDetails(item) {
      this.name = item.title;
      this.code = item.code;
      this.status_form = item.id;

    },
    get_categories() {
      var self = this;
      var formData = new FormData();
      formData.append('id', this.$route.params.id)
      formData.append('admin_id', this.$route.params.admin_id)
      axios.post('/api/admin/site/get_line_info', formData, {show_pros: false}).then(function (response) {

        var content_cats = response.data;

        self.admin_info = content_cats.user
        self.line_info = content_cats.data

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_line_reserve_times() {
      var self = this;
      var formData = new FormData();
      formData.append('id', this.$route.params.id)
      formData.append('selected_date', this.selected_date)
      formData.append('admin_id', this.$route.params.admin_id)
      axios.post('/api/admin/site/get_line_reserve_times', formData, {show_pros: false}).then(function (response) {

        var content_cats = response.data;

        self.line_reserves = content_cats.data

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    change_time_status(reserve) {
      var self = this;
      var formData = new FormData();
      formData.append('id', this.$route.params.id)
      formData.append('reserve_id', reserve.id)
      formData.append('admin_id', this.$route.params.admin_id)
      axios.post('/api/admin/site/change_time_status', formData, {show_pros: false}).then(function (response) {

        self.$root.modal_component.show_api_response_modals(response);
       self.get_line_reserve_times();
      })
          .catch(function (error) {

            console.log(error);
          });

    },


    login() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/site/add_line_reserve_times";
      }
      formData.append('id', this.$route.params.id)
      formData.append('admin_id', this.$route.params.admin_id)

      formData.append('start_time', this.start_time);
      formData.append('end_time', this.end_time);
      formData.append('every_minute', this.every_minute);
      formData.append('selected_date', this.selected_date);

      axios.post(url, formData, {show_pros: false}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        if (res.data.error == 0) {

          self.get_line_reserve_times();
        }

      })


          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("warning"), this.$t("deleteMessage"), [this.$t("ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item_dialog_one(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("warning"), this.$t("deleteMessage"), [this.$t("ok")], this.confirm_delete_name_one);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/delete_line_reserve_times";

      formData.append('admin_id', this.$route.params.admin_id)
      formData.append('id', this.$route.params.id);
      formData.append('selected_date', this.selected_date);

      axios.post(url, formData, {show_pros: false}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_line_reserve_times();


      })
          .catch(function (error) {
            console.log(error);
          });
    },
    delete_item_one() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/delete_line_reserve_times_one";

      formData.append('admin_id', this.$route.params.admin_id)
      formData.append('id', this.$route.params.id);
      formData.append('selected_date', this.selected_date);
      formData.append('selected_time', this.status_form);

      axios.post(url, formData, {show_pros: false}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_line_reserve_times();


      })
          .catch(function (error) {
            console.log(error);
          });
    },
  }
}


</script>
<style>
/* استایل بلوک اطلاعات کاربر و لاین */
.user-line-info {
  padding: 10px 0;
}

.user-avatar {
  object-fit: cover;
  border: 2px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.user-line-details h5 {
  font-size: 1.1rem;
  color: #333;
}

.user-line-details p {
  font-size: 0.95rem;
}

/* استایل سکشن تقویم جدید */
.calendar-section {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.calendar-section .vpd-wrapper {
  width: 100%;
  max-width: 100%;
}

/* استایل راهنمای تقویم */
.calendar-guide {
  text-align: center;
  padding: 5px 10px;
}

.calendar-guide small {
  font-size: 0.75rem;
  display: inline-flex;
  align-items: center;
}

.calendar-guide i {
  font-size: 0.7rem;
}

/* استایل بخش ساعات رزرو */
.reserve-times-section {
  border-top: 1px solid #e0e0e0;
  padding-top: 15px;
  margin-top: 15px;
}

.reserve-times-section .reserve_time_list {
  margin-top: 10px;
}

/* استایل بلوک ثبت ساعات رزرو */
.reserve-form-section {
  margin-top: 20px;
}

.reserve-form-section .card-body {
  padding: 1rem;
}

.reserve-form-section .card-footer {
  padding: 0.75rem 1rem;
}

/* استایل برای موبایل */
@media screen and (max-width: 768px) {
  .user-line-info {
    padding: 8px 0;
  }
  
  .user-avatar {
    width: 60px !important;
    height: 60px !important;
  }
  
  .user-line-details h5 {
    font-size: 1rem;
  }
  
  .user-line-details p {
    font-size: 0.9rem;
  }
  
  .calendar-section {
    padding: 5px;
  }
  
  .calendar-guide {
    padding: 4px 8px;
  }
  
  .calendar-guide small {
    font-size: 0.7rem;
  }
  
  .reserve-times-section {
    padding-top: 10px;
    margin-top: 10px;
  }
  
  .reserve-form-section {
    margin-top: 15px;
  }
  
  /* بهبود فاصله‌گذاری در موبایل */
  .reserve-form-section .col-6 {
    padding-left: 8px;
    padding-right: 8px;
  }
}

@media screen and (max-width: 576px) {
  .user-line-info {
    padding: 6px 0;
    flex-wrap: nowrap;
  }
  
  .user-avatar {
    width: 50px !important;
    height: 50px !important;
    flex-shrink: 0;
  }
  
  .user-line-details {
    flex: 1;
    margin-left: 10px;
  }
  
  .user-line-details h5 {
    font-size: 0.95rem;
  }
  
  .user-line-details p {
    font-size: 0.85rem;
  }
  
  .calendar-section {
    padding: 3px;
  }
  
  .calendar-guide {
    padding: 3px 5px;
  }
  
  .calendar-guide small {
    font-size: 0.65rem;
  }
  
  .calendar-guide i {
    font-size: 0.6rem;
  }
  
  .reserve-times-section {
    padding-top: 8px;
    margin-top: 8px;
  }
  
  .reserve-form-section {
    margin-top: 12px;
  }
  
  /* در موبایل کوچک، از ساعت و تا ساعت در یک خط */
  .reserve-form-section .col-6 {
    padding-left: 5px;
    padding-right: 5px;
  }
  
  .reserve-form-section .col-md-6 {
    margin-bottom: 0.75rem;
  }
}

.reserve_time_list{
  display: flex;
  flex-flow: wrap;
}
.reserve_time_parent{
  border: 1px solid #2eb85c;
display: flex;
  margin: 5px;
}
.reserve_time_item{
  background: #2eb85c36;
  padding: 7px;
  margin: 2px;
  border-radius: 5px;
  cursor: pointer;
  min-width: 60px;
  text-align: center;
}

.reserve_time_item.reserved{
color:white;
  background: #39f;
}

.reserve_time_item.disabled{
  color: #999;
  background: #f5f5f5;
  opacity: 0.7;
  position: relative;
  overflow: hidden;
}

.reserve_time_item.disabled::after {
  content: '';
  position: absolute;
  top: 50%;
  left: -50%;
  width: 200%;
  height: 2px;
  background: #dc3545;
  transform: rotate(-45deg);
  transform-origin: center;
  pointer-events: none;
  z-index: 1;
  box-shadow: 0 0 2px rgba(220, 53, 69, 0.5);
}

/* استایل برای موبایل به صورت افقی */
@media screen and (max-width: 1024px) and (orientation: landscape) {
  .reserve_time_list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;
    max-height: 200px;
    overflow-y: auto;
  }
  
  .reserve_time_item {
    flex: 0 0 auto;
    padding: 8px 12px;
    margin: 0;
    font-size: 0.9rem;
    min-width: 70px;
  }
}

/* استایل برای موبایل کوچک به صورت افقی */
@media screen and (max-width: 768px) and (orientation: landscape) {
  .reserve_time_list {
    max-height: 150px;
    gap: 4px;
  }
  
  .reserve_time_item {
    padding: 6px 10px;
    font-size: 0.85rem;
    min-width: 65px;
  }
}

/* استایل برای موبایل خیلی کوچک به صورت افقی */
@media screen and (max-width: 576px) and (orientation: landscape) {
  .reserve_time_list {
    max-height: 120px;
    gap: 3px;
  }
  
  .reserve_time_item {
    padding: 5px 8px;
    font-size: 0.8rem;
    min-width: 60px;
  }
}

/* استایل‌های واکنش‌گرا برای تقویم در موبایل */
@media screen and (max-width: 768px) {
  /* کاهش اندازه تقویم */
  .vpd-wrapper {
    max-width: 100% !important;
    font-size: 0.85rem !important;
    padding: 5px !important;
  }
  
  .vpd-calendar {
    width: 100% !important;
    max-width: 100% !important;
    padding: 5px !important;
  }
  
  .vpd-calendar-header {
    padding: 6px 2px !important;
    font-size: 0.8rem !important;
    margin-bottom: 5px !important;
  }
  
  .vpd-calendar-day {
    padding: 4px 2px !important;
    font-size: 0.75rem !important;
    min-height: 30px !important;
    min-width: 30px !important;
    margin: 1px !important;
    line-height: 1.2 !important;
  }
  
  .vpd-calendar-day-name {
    padding: 4px 1px !important;
    font-size: 0.7rem !important;
    font-weight: 600 !important;
  }
  
  .vpd-month-label,
  .vpd-year-label {
    font-size: 0.85rem !important;
    padding: 3px 6px !important;
    margin: 0 2px !important;
  }
  
  .vpd-nav-btn {
    padding: 3px 6px !important;
    font-size: 0.85rem !important;
    min-width: 30px !important;
    min-height: 30px !important;
  }
  
  /* بهبود لایه‌بندی در موبایل */
  .col-md-6 {
    margin-bottom: 15px;
  }
  
  /* کاهش فاصله بین ردیف‌ها */
  .vpd-calendar-row {
    margin: 0 !important;
  }
}

/* استایل برای موبایل‌های کوچک */
@media screen and (max-width: 576px) {
  .vpd-wrapper {
    font-size: 0.75rem !important;
    padding: 3px !important;
  }
  
  .vpd-calendar {
    padding: 3px !important;
  }
  
  .vpd-calendar-day {
    padding: 3px 1px !important;
    font-size: 0.7rem !important;
    min-height: 28px !important;
    min-width: 28px !important;
    margin: 1px !important;
  }
  
  .vpd-calendar-day-name {
    padding: 3px 1px !important;
    font-size: 0.65rem !important;
  }
  
  .vpd-calendar-header {
    padding: 4px 1px !important;
    font-size: 0.75rem !important;
    margin-bottom: 3px !important;
  }
  
  .vpd-month-label,
  .vpd-year-label {
    font-size: 0.8rem !important;
    padding: 2px 4px !important;
    margin: 0 1px !important;
  }
  
  .vpd-nav-btn {
    padding: 2px 4px !important;
    font-size: 0.8rem !important;
    min-width: 28px !important;
    min-height: 28px !important;
  }
  
  /* بهبود فاصله‌گذاری */
  .card-body {
    padding: 10px !important;
  }
  
  /* کاهش فاصله بین سلول‌ها */
  .vpd-calendar-day {
    border-width: 1px !important;
  }
}

/* استایل برای موبایل در حالت عمودی */
@media screen and (max-width: 768px) and (orientation: portrait) {
  .vpd-calendar {
    padding: 5px !important;
  }
  
  .vpd-calendar-day {
    margin: 1px !important;
  }
  
  /* بهبود نمایش در حالت عمودی */
  .vpd-wrapper {
    transform: scale(0.95);
    transform-origin: top center;
  }
}

/* بهبود نمایش در تبلت */
@media screen and (min-width: 577px) and (max-width: 992px) {
  .vpd-calendar-day {
    padding: 6px 3px !important;
    font-size: 0.8rem !important;
    min-height: 35px !important;
    min-width: 35px !important;
  }
  
  .vpd-calendar-header {
    padding: 8px 3px !important;
  }
}

/* بهبود کارت‌ها و دکمه‌ها در موبایل */
@media screen and (max-width: 768px) {
  .card-header {
    padding: 0.75rem 0.5rem !important;
  }
  
  .card-header img {
    width: 50px !important;
    height: 50px !important;
  }
  
  .card-header strong {
    font-size: 0.9rem !important;
  }
  
  .card-body {
    padding: 0.75rem !important;
  }
  
  .card-footer {
    padding: 0.5rem !important;
  }
  
  .btn-sm {
    padding: 0.25rem 0.5rem !important;
    font-size: 0.8rem !important;
  }
  
  /* بهبود فاصله بین ستون‌ها */
  .col-md-6 {
    margin-bottom: 1rem;
  }
  
  /* بهبود نمایش تصویر در هدر */
  .d-flex.align-items-center {
    flex-wrap: wrap;
  }
  
  .d-flex.align-items-center img {
    margin-bottom: 0.5rem;
  }
  
  /* بهبود قابلیت لمس در موبایل */
  .vpd-calendar-day {
    touch-action: manipulation;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
  }
  
  .vpd-nav-btn {
    touch-action: manipulation;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }
  
  /* بهبود نمایش اعداد در سلول‌ها */
  .vpd-calendar-day span {
    display: block;
    width: 100%;
    text-align: center;
  }
}

/* بهبود نمایش در موبایل‌های کوچک */
@media screen and (max-width: 576px) {
  .card-header {
    padding: 0.5rem !important;
  }
  
  .card-header img {
    width: 45px !important;
    height: 45px !important;
  }
  
  .card-header strong {
    font-size: 0.85rem !important;
    line-height: 1.4;
  }
  
  .card-body {
    padding: 0.5rem !important;
  }
  
  .btn-sm {
    padding: 0.2rem 0.4rem !important;
    font-size: 0.75rem !important;
  }
  
  /* بهبود نمایش لیست زمان‌های رزرو */
  .reserve_time_list {
    gap: 4px;
  }
  
  .reserve_time_item {
    padding: 6px 8px !important;
    font-size: 0.8rem !important;
    min-width: 55px !important;
  }
  
  /* بهبود قابلیت لمس در موبایل‌های کوچک */
  .vpd-calendar-day {
    touch-action: manipulation;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
    user-select: none;
  }
  
  /* کاهش فاصله بین ردیف‌های تقویم */
  .vpd-calendar table {
    border-spacing: 1px !important;
    border-collapse: separate !important;
  }
  
  /* بهبود نمایش هدر تقویم */
  .vpd-calendar-header .vpd-nav-btn {
    font-size: 0.75rem !important;
  }
}

/* استایل برای موبایل‌های خیلی کوچک (تا 400px) */
@media screen and (max-width: 400px) {
  .vpd-calendar-day {
    min-height: 26px !important;
    min-width: 26px !important;
    font-size: 0.65rem !important;
    padding: 2px 1px !important;
  }
  
  .vpd-calendar-day-name {
    font-size: 0.6rem !important;
    padding: 2px 1px !important;
  }
  
  .vpd-month-label,
  .vpd-year-label {
    font-size: 0.75rem !important;
    padding: 2px 3px !important;
  }
  
  .vpd-nav-btn {
    min-width: 26px !important;
    min-height: 26px !important;
    font-size: 0.75rem !important;
    padding: 2px 3px !important;
  }
  
  .vpd-calendar-header {
    padding: 3px 1px !important;
    font-size: 0.7rem !important;
  }
}

/* استایل‌های کلی برای بهبود نمایش تقویم در موبایل */
@media screen and (max-width: 768px) {
  /* بهبود نمایش اعداد در سلول‌های تقویم */
  .vpd-calendar-day-number {
    font-weight: 500 !important;
  }
  
  /* بهبود نمایش روزهای انتخاب شده */
  .vpd-calendar-day.selected {
    font-weight: 700 !important;
  }
  
  /* بهبود نمایش روزهای غیرفعال */
  .vpd-calendar-day.disabled {
    opacity: 0.4 !important;
  }
  
  /* بهبود نمایش روزهای امروز */
  .vpd-calendar-day.today {
    font-weight: 700 !important;
  }
  
  /* بهبود نمایش نشانگر تعداد رزرو */
  .vpd-calendar-day .badge,
  .vpd-calendar-day .vpd-badge {
    font-size: 0.6rem !important;
    padding: 1px 3px !important;
    min-width: 14px !important;
    height: 14px !important;
    line-height: 12px !important;
  }
  
  /* بهبود نمایش جدول تقویم */
  .vpd-calendar table {
    width: 100% !important;
    table-layout: fixed !important;
  }
  
  .vpd-calendar table td {
    width: calc(100% / 7) !important;
  }
}

/* بهبود نمایش در موبایل‌های کوچک */
@media screen and (max-width: 576px) {
  .vpd-calendar-day .badge,
  .vpd-calendar-day .vpd-badge {
    font-size: 0.55rem !important;
    padding: 1px 2px !important;
    min-width: 12px !important;
    height: 12px !important;
    line-height: 10px !important;
  }
}
.btn-primary {
  padding: 12px 32px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary:hover:not(:disabled) {
  background: #66b1ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.btn-primary:disabled {
  background: #a0cfff;
  cursor: not-allowed;
}
</style>